export default __webpack_public_path__ + "static/media/Farmhouse.f8fe358b.jpg";